var map = {
	"./mambo.mp3": 3265,
	"./swing.mp3": 3266,
	"./tango.mp3": 3267
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/dances .\.mp3*
// module id = 384
// module chunks = 0